import { css } from '@emotion/react';
import type { ScheduleActivityItem } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_activity.pb';
import { getFullName } from '@frontend/name';
import { useContactPanelShallowStore } from '@frontend/shared';
import { Avatar, Text, Truncated } from '@frontend/design-system';

export const PatientCellRenderer = ({ row }: { row: ScheduleActivityItem }) => {
  const { setPersonId, setSelectedTab } = useContactPanelShallowStore('setPersonId', 'setSelectedTab');

  if (!row?.patient?.firstName && !row?.patient?.lastName) {
    return <Text size='medium'>-</Text>;
  }

  const handleAvatarClick = () => {
    if (!row?.patient?.patientId) return;

    const personId = row.patient.patientId;
    setPersonId(personId, true);
    setSelectedTab('overview-tab');
  };

  return (
    <div css={containerstyles}>
      {/* TODO: Use patient image when API is ready */}
      <Avatar name={getFullName(row.patient)} size='small' onClick={handleAvatarClick} />
      <Truncated
        css={patientNameStyles}
        TooltipComponent={
          <Text size='medium' color='white'>
            {getFullName(row.patient)}
          </Text>
        }
      >
        <Text as='span' size='medium' weight='bold'>
          {row.patient.firstName}
        </Text>
        {row.patient.firstName && row.patient.lastName ? ' ' : null}
        <Text as='span' size='medium'>
          {row.patient.lastName}
        </Text>
      </Truncated>
    </div>
  );
};

const containerstyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xs);
  width: 100%;
`;

const patientNameStyles = css`
  flex: 1 1 auto;
  min-width: 0;
`;
